<template>
  <div
    class="messages chat"
    :class="[loadingContent ? 'loading large' : '']"
    :data-cy="data.ticketId ? `ticket-id-${data.ticketId}` : null"
  >
    <div
      v-show="!loadingContent"
      class="box-chat"
      data-tutorial="chat-box"
    >
      <lila-message :alert-data="alert" />

      <div class="buttons-chat-container">
        <button
          v-show="data.ticketId && hasFeatureId(13)"
          class="button video"
          :disabled="loading"
          @click="openVideoCall()"
        >
          <img
            src="@/assets/icons/video_call.svg"
            alt=""
            class="icon"
          >
          <span>{{ loading ? "Conectando..." : "Vídeo" }}</span>
        </button>
        <div class="buttons-right">
          <button
            v-show="
              data.ticketId != null &&
                (userProfile == 'doctor' ||
                  userProfile == 'professional_leader' ||
                  (userProfile == 'professional_default' && chatOwner))
            "
            :class="[
              'button',
              'transfer-ticket',
              { 'transfer-ticket-premium': !hasFeatureId(1) }
            ]"
            :disabled="!hasFeatureId(1)"
            @click="openTransferToProfessionalModal()"
            @mouseover="showText = true"
            @mouseout="showText = false"
          >
            <span
              v-show="showText && !hasFeatureId(1)"
              class="tooltip"
            >
              Disponível apenas para assinantes!
            </span>
            <img
              src="@/assets/icons/transfer.svg"
              alt=""
              class="icon"
            >
            Transferir
            <i
              v-if="!hasFeatureId(1)"
              class="fas fa-star"
            />
          </button>
          <button
            v-show="
              data.ticketId != null &&
                (userProfile == 'doctor' ||
                  userProfile == 'professional_leader' ||
                  (userProfile == 'professional_default' && chatOwner))
            "
            class="button close-ticket"
            @click="closeTicket()"
          >
            <img
              src="@/assets/icons/cancel_icon.svg"
              alt=""
              class="icon"
            >
            <span>Encerrar</span>
          </button>
          <lila-chat-outcome
            v-model="showModalOutcome"
            :ticket-id="data.ticketId"
            :patient-id="data.patientId"
            :alert="alert"
            @ticket-closed="handleTicketClosed"
            @remove-ticket="removeTicket"
          />
          <lila-confirm-close-ticket
            v-model="showModalconfirmCloseTicket"
            :ticket-id="data.ticketId"
            :alert="alert"
          />
        </div>
      </div>

      <div
        v-show="data.ticketId == null && !openChat"
        class="idle-chat-text"
      >
        <p
          v-if="data.closedTicket"
          class="idle-text purple-text has-text-centered"
        >
          O chamado foi encerrado
        </p>
        <p
          v-else
          class="idle-text purple-text has-text-centered"
        >
          Você não tem uma conversa aberta com esse paciente
        </p>

        <p
          v-if="data.closedTicket"
          class="text-1 grey-text has-text-centered"
        >
          Deseja iniciar uma nova conversa?
        </p>
        <p
          v-else
          class="text-1 grey-text has-text-centered"
        >
          Deseja iniciar uma conversa?
        </p>

        <lila-button
          type="button"
          title="Iniciar Conversa"
          class="button"
          :is-centralized="true"
          @custom-click-event="openTheChat()"
        />
      </div>

      <div
        ref="messagesListBox"
        class="messages-list custom-scroll"
      >
        <div v-if="data.ticketId != null || openChat">
          <lila-chat-message
            v-for="(item, index) in data.messageList"
            :key="`chat-message-${index}`"
            :message="item"
            :last-date="
              index <= 0 ? undefined : data.messageList[index - 1].DateAndTime
            "
            @edit="startEditMessage"
          />
        </div>
      </div>

      <lila-transfer-ticket
        :modal-transfer-to-professional-active="
          modalTransferToProfessionalActive
        "
        :close-transfer-to-professional-modal="closeTransferToProfessionalModal"
        :patient-id="data.patientId"
        :user-id="userId"
        :ticket-id="data.ticketId"
        :alert="alert"
      />

      <lila-message-typer
        :data="data"
        :open-chat="openChat"
        :chat-owner="chatOwner"
        :loading="loading"
        :alert="alert"
        :editing-message="editingMessage"
        :scroll-chat-to-bottom="scrollChatToBottom"
        :set-chat-attributes="setChatAttributes"
        :open-transfer-to-professional-modal="openTransferToProfessionalModal"
        @cancel-edit="cancelEditMessage"
        @message-edited="onMessageEdited"
      />
    </div>
  </div>
</template>

<script>
import Button from "@components/shared/button/Button.vue";
import Message from "@components/shared/message/Message.vue";
import LilaChatMessage from "@components/Chat/LilaChatMessage.vue";
import LilaChatOutcome from "@components/Chat/LilaChatOutcome.vue";
import LilaConfirmCloseTicket from "@components/Chat/LilaConfirmCloseTicket.vue";
import LilaMessageTyper from "@components/Chat/LilaMessageTyper.vue";
import decodeToken from "../../../js/decodeToken.js";
import LilaTransferTicket from "../../../components/Chat/LilaTransferTicket.vue";
import CallWindow from "@/views/videoCall/CallWindow.vue";
import { Feature } from "@/enums/Feature";

require("@microsoft/signalr");

export default {
  components: {
    "lila-button": Button,
    "lila-message": Message,
    LilaChatMessage,
    LilaChatOutcome,
    LilaMessageTyper,
    LilaConfirmCloseTicket,
    LilaTransferTicket,
    CallWindow
  },
  props: {
    closedTicketId: {
      type: Number, // Definindo o tipo como Number
      required: false, // A prop não é obrigatória
      default: null // Valor padrão quando não for fornecida
    },
    newMessageForPatient: {
      type: Object, // Definindo o tipo como Object
      required: false, // A prop não é obrigatória
      default: () => ({}) // Valor padrão como um objeto vazio
    },
    selectedPatient: {
      type: Object,
      required: false,
      default: null
    }
  },
  emits: [
    "updateTicketMessage", // Adiciona o evento emitido
    "removeTicket" // Adiciona o evento emitido
  ],
  data() {
    return {
      features: [],
      videoCallId: null,
      showVideoCallModal: false,
      userId: null,
      chatOwnerId: 0,
      userProfile: "",
      data: {
        patientId: this.$route.params.id,
        ticketId: null,
        closedTicket: false,
        date: "",
        doctorPriority: "",
        messageList: [],
        message: "",
        file: {
          title: "",
          content: ""
        },
        tempDate: "",
        tempDoctorPriority: ""
      },
      editingMessage: null,
      tempDate: "",
      professionalList: [],
      selectedProfessional: null,
      modalReclassifyUrgencyActive: false,
      loadingCreateChat: false,
      loadingContent: false,
      loadingSignalR: false,
      sendingMessage: false,
      changingUrgency: false,
      showModalOutcome: false,
      showModalconfirmCloseTicket: false,
      openChat: false,
      alert: {
        message: "",
        type: "",
        show: false
      },
      chatSignalR: {
        active: false,
        connection: null,
        timeout: false,
        retryCount: 0
      },
      signalRTimeout: 0,
      signalRMaxRetry: 3,
      loading: false,
      deletingAllTickets: false,
      deletingAllSymptomsAlerts: false,
      patientColumnHeight: 0,
      patientColumnHeightInterval: null,
      modalTransferToProfessionalActive: false,
      sendingTransferToProfessional: false,
      showText: false
    };
  },
  computed: {
    hasVideoCall() {
      return this.features?.includes(Feature.VideoChamada) ?? false;
    },
    chatOwner() {
      return (
        this.chatOwnerId == 0 ||
        (this.$Session.get(this.$userSessionName).professional != null &&
          this.chatOwnerId ==
            this.$Session.get(this.$userSessionName).professional.Id) ||
        this.$Session.get(this.$userSessionName).profile ==
          "professional_leader" ||
        this.$Session.get(this.$userSessionName).profile == "professional_admin"
      );
    }
  },
  watch: {
    $route(to) {
      this.data.patientId = to.params.id;
      this.chatOwnerId = 0;
      this.v.$reset();
      this.getChat();
    },
    closedTicketId: {
      handler: function () {
        if (this.closedTicketId == this.data.ticketId) this.closeChat();
      }
    },
    newMessageForPatient: {
      handler: function () {
        if (
          this.newMessageForPatient.patientId == this.data.patientId &&
          this.data.ticketId == null
        )
          this.getChat();
      }
    }
  },
  mounted() {
    this._callMessageHandler = (event) => {
      if (event.origin !== window.location.origin) return;
      const { type, patientId } = event.data || {};
      if (type !== "call-finished") return;
      if (String(patientId) !== String(this.data.patientId)) return;

      setTimeout(() => this.getChat(), 500);
    };
    window.addEventListener("message", this._callMessageHandler);
  },
  created() {
    const decoded = decodeToken(
      this.$Session.get(this.$userSessionName).token.Value
    );

    const features = decoded?.FeaturesId;

    this.features = Array.isArray(features)
      ? features.map(Number)
      : typeof features === "string"
        ? features.split(",").map(Number)
        : [];
    this.userProfile = this.$Session.get(this.$userSessionName).profile;
    this.userId = this.$Session.get(this.$userSessionName).professional.Id;

    this.getChat();

    this.startChatSignalR();
  },
  beforeUnmount() {
    this.closeSignalRConnections();
    if (this._callMessageHandler) window.removeEventListener("message", this._callMessageHandler);
  },
  methods: {
    async getPatientName() {
      try {
        const response = await this.$axios.get(
          `/api/patient/${this.data.patientId}`,
          {
            headers: {
              Authorization: `bearer ${
                this.$Session.get(this.$userSessionName).token.Value
              }`
            }
          }
        );
        return response.data?.Name || "Paciente";
      } catch {
        return "Paciente";
      }
    },
    async openVideoCall() {
      if (!this.data.ticketId) {
        this.$Utilities.controlAlert(
          "Não há chamado aberto para iniciar uma videochamada",
          this.alert,
          "danger"
        );
        return;
      }

      this.loading = true;

      try {
        const response = await this.$axios.post(
          `/api/call/patient/${this.data.patientId}`,
          {},
          {
            headers: {
              Authorization: `bearer ${
                this.$Session.get(this.$userSessionName).token.Value
              }`
            }
          }
        );

        const callData = response.data;
        const videoCallId = callData.VideoCallId;

        const professional = this.$Session.get(
          this.$userSessionName
        )?.professional;
        localStorage.setItem(
          `videoCall_${videoCallId}`,
          JSON.stringify({
            videoCallId: callData.VideoCallId,
            channelName: callData.ChannelName,
            token: callData.Token,
            appId: callData.AppId,
            uid: callData.Uid,
            patientId: this.data.patientId,
            patientName: await this.getPatientName(),
            professionalName: professional?.Name || "Profissional",
            professionalId: String(this.userId)
          })
        );

        await this.initiateVideoCall(videoCallId);
      } catch (error) {
        this.$Utilities.verifyToken(error.response?.status);
        this.$Utilities.controlAlert(
          error.response?.data || "Erro ao criar videochamada",
          this.alert,
          "danger"
        );
      } finally {
        this.loading = false;
      }
    },

    async initiateVideoCall(videoCallId) {
      try {
        await this.$axios.post(
          `/api/call/${videoCallId}/initiate`,
          {},
          {
            headers: {
              Authorization: `bearer ${
                this.$Session.get(this.$userSessionName).token.Value
              }`
            }
          }
        );

        window.open(
          `/videocall/${videoCallId}`,
          "_blank",
          "width=1280,height=720"
        );
      } catch (error) {
        this.$Utilities.verifyToken(error.response?.status);
        this.$Utilities.controlAlert(
          error.response?.data || "Erro ao iniciar videochamada",
          this.alert,
          "danger"
        );
      }
    },
    onRemoveTicket(patientId) {
      this.$root.$emit("remove-ticket", patientId);
    },
    getChat() {
      this.alert.show = false;
      this.loadingContent = true;

      this.closeChat();

      this.$axios
        .get(`/api/chat/patient/${this.data.patientId}`, {
          headers: {
            Authorization: `bearer ${
              this.$Session.get(this.$userSessionName).token.Value
            }`
          }
        })
        .then((res) => {
          this.setChatAttributes(res.data);

          this.scrollChatToBottom();
        })
        .catch((error) => {
          this.$Utilities.verifyToken(error.response.status);

          if (error.response.status != 404)
            this.$Utilities.controlAlert(
              error.response.data,
              this.alert,
              "danger"
            );
        })
        .finally(() => (this.loadingContent = false));
    },
    setChatAttributes(data) {
      this.data.ticketId = data.Id;
      this.data.closedTicket = false;
      this.data.date = data.Date;
      this.data.doctorPriority = data.DoctorPriority;
      this.data.tempDoctorPriority = data.DoctorPriority;
      this.data.messageList = data.Messages[0] != null ? data.Messages : [];
      this.chatOwnerId = data.ClosingProfessionalId;
    },
    openTheChat() {
      this.openChat = true;
    },
    closeTicket() {
      const featureCloseTicketWithOutcomes = 0;
      if (this.hasFeatureId(featureCloseTicketWithOutcomes)) {
        this.openLilaChatOutcome();
      } else {
        this.openConfirmCloseTicket();
      }
    },
    openLilaChatOutcome() {
      this.showModalOutcome = true;
    },
    openConfirmCloseTicket() {
      this.showModalconfirmCloseTicket = true;
    },
    hasFeatureId(featureId) {
      const decodedToken = decodeToken(
        this.$Session.get(this.$userSessionName).token.Value
      );
      return decodedToken && decodedToken.FeaturesId.includes(featureId);
    },
    scrollChatToBottom() {
      setTimeout(
        function ($this) {
          if (
            !$this.$refs.messagesListBox ||
            !$this.$refs.messagesListBox.scrollTo ||
            !$this.$refs.messagesListBox.scrollHeight
          )
            return;
          $this.$refs.messagesListBox.scrollTo(
            0,
            $this.$refs.messagesListBox.scrollHeight
          );
        },
        500,
        this
      );
    },
    verifyCurrentDate(date) {
      if (
        this.tempDate == "" ||
        this.$moment(date, "YYYY-MM-DD").unix() >
          this.$moment(this.tempDate, "YYYY-MM-DD").unix()
      ) {
        this.tempDate = date;

        return true;
      } else {
        return false;
      }
    },
    openTransferToProfessionalModal() {
      this.modalTransferToProfessionalActive = true;
    },
    closeTransferToProfessionalModal() {
      this.v.$reset();
      this.modalTransferToProfessionalActive = false;
    },
    resetCardOnMessageFromProfessional(priority, message) {
      this.$emit(
        "updateTicketMessage",
        priority,
        this.data.patientId,
        message,
        this.data.messageList[this.data.messageList.length - 1].DateAndTime
      );
    },
    removeTicket() {
      this.$emit("remove-ticket", this.data.patientId);
    },
    handleTicketClosed() {
      this.$emit("remove-ticket", this.data.patientId);

      this.closeChat();
    },
    closeChat() {
      this.openChat = false;
      this.data.ticketId = null;
      this.data.closedTicket = true;
      this.data.date = "";
      this.data.doctorPriority = "";
      this.data.tempDoctorPriority = "";
      this.data.messageList = [];
      this.editingMessage = null;
      this.data.message = "";
    },
    updateChatMessageByProfessional(data) {
      if (data.professional.id == this.userId) return;

      let formData = new FormData();
      let newData = Object.entries(data).reduce(function (item, [key, value]) {
        item[key[0].toUpperCase() + key.slice(1)] = value;
        return item;
      }, {});

      if (data.ticketId == this.data.ticketId) {
        this.data.messageList.push(newData);
      }

      if (data.message) formData.append("Message", data.message.trim());
      if (data.attachedDocument)
        formData.append("AttachedDocument", data.attachedDocument);

      this.scrollChatToBottom();
    },
    updateChatMessageByPatient(data) {
      let formData = new FormData();
      let newData = {};
      for (let key in data) {
        newData[key[0].toUpperCase() + key.slice(1)] = data[key];
      }
      const tzoffset = new Date().getTimezoneOffset() * 60000;
      newData.DateAndTime = new Date(Date.now() - tzoffset)
        .toISOString()
        .slice(0, 19);

      if (data.ticketId == this.data.ticketId) {
        // Uma nova mensagem do paciente "responde" as anteriores, que deixam
        // de ser editáveis. Ajustamos o canEdit localmente (o backend já
        // aplica a mesma regra; aqui só refletimos na hora, sem reload).
        this.disableEditOnAllMessages();
        this.data.messageList.push(newData);

        // Se o profissional estava editando uma mensagem que acabou de ser
        // respondida, encerra a edição (ela não pode mais ser salva).
        if (this.editingMessage) {
          this.cancelEditMessage();
          this.$Utilities.controlAlert(
            null,
            this.alert,
            "warning",
            "A mensagem foi respondida pelo paciente e não pode mais ser editada."
          );
        }
      }
      if (data.message) formData.append("Message", data.message.trim());
      if (data.attachedDocument)
        formData.append("AttachedDocument", data.attachedDocument);

      this.scrollChatToBottom();
    },
    // Zera o canEdit de todas as mensagens já na lista. Substitui os objetos
    // (nova referência) para garantir a reatividade — o lápis some na hora.
    disableEditOnAllMessages() {
      this.data.messageList = this.data.messageList.map((message) => {
        const key = Object.keys(message).find(
          (k) => k.toLowerCase() === "canedit"
        );
        return { ...message, [key || "CanEdit"]: false };
      });
    },
    // Substitui uma mensagem da lista pelos dados atualizados (edição).
    // Normaliza as chaves para PascalCase para casar com a lista atual,
    // assim funciona tanto para resposta REST quanto para payload SignalR.
    replaceMessageInList(data) {
      if (data == null) return;

      const normalized = Object.entries(data).reduce(
        function (item, [key, value]) {
          item[key[0].toUpperCase() + key.slice(1)] = value;
          return item;
        },
        {}
      );

      const id = normalized.Id;
      if (id == null) return;

      const index = this.data.messageList.findIndex(
        (message) => message.Id == id
      );

      if (index !== -1) {
        this.data.messageList.splice(index, 1, {
          ...this.data.messageList[index],
          ...normalized
        });
      }
    },
    // Clicou no lápis: carrega o texto na barra inferior e entra em modo edição.
    startEditMessage(message) {
      this.alert.show = false;
      this.editingMessage = message;
      this.data.message =
        message.Message != null ? message.Message : message.message || "";
    },
    // Cancelou a edição na barra inferior.
    cancelEditMessage() {
      this.editingMessage = null;
      this.data.message = "";
    },
    // PUT concluído com sucesso (200): atualiza a lista e sai do modo edição.
    onMessageEdited(updatedMessage) {
      this.replaceMessageInList(updatedMessage);
      this.editingMessage = null;
      this.data.message = "";
    },
    // Edição recebida em tempo real (paciente editou). O nome do evento
    // SignalR deve ser confirmado com o backend.
    updateEditedChatMessage(data) {
      if (data == null) return;
      if (data.ticketId != null && data.ticketId != this.data.ticketId) return;

      this.replaceMessageInList(data);
    },
    handleOpenTransferencias() {
      this.showTransferenciasComponent = true;
    },
    async startChatSignalR() {
      try {
        if (this.chatSignalR.connection != null) return true;

        this.chatSignalR.connection = await this.$SignalRConnector.startSignalR(
          "messageprofessionalhub",
          (connection) => {
            this.startChatSignalRListeners(connection);
          },
          this.signalRTimeout,
          String(this.userId),
          "chat"
        );
      } catch (erro) {
        if (this.chatSignalR.retryCount < this.signalRMaxRetry) {
          ++this.chatSignalR.retryCount;

          const delay = this.chatSignalR.retryCount * 2000;
          await new Promise((resolve) => setTimeout(resolve, delay));

          await this.startChatSignalR();
        }
      }
    },

    async startChatSignalRListeners(connection) {
      connection.on("PatientMessage", (res) => {
        this.loadingSignalR = true;
        this.updateChatMessageByPatient(res);
        this.loadingSignalR = false;
      });

      connection.on("ProfessionalMessage", (chat, message) => {
        this.loadingSignalR = true;
        this.updateChatMessageByProfessional(message);
        this.loadingSignalR = false;
      });

      connection.on("MessageEdited", (res) => {
        this.loadingSignalR = true;
        this.updateEditedChatMessage(res);
        this.loadingSignalR = false;
      });
    },

    closeSignalRConnections() {
      this.$SignalRConnector.stopSignalR(this.chatSignalR.connection, "chat");

      this.chatSignalR.active = false;
    }
  }
};
</script>

<style>
@import "~@assets/css/views/chat.css";
</style>
